import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryListRangeGoodReport  {
    _originalTypeClassName = "zERP.BO.InventoryListRangeGoodReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryListRangeGoodReport.translate = translateService;
}
this.GoodCode = null;
this.GoodName = null;
this.PreviousAmount = null;
this.PreviousValue = null;
this.ImportAmount = null;
this.ImportValue = null;
this.ExportAmount = null;
this.ExportValue = null;
this.TotalAmount = null;
this.TotalValue = null;
this.InventoryListRangeGoodReportKey = null;
this._key = this.InventoryListRangeGoodReportKey = 0; 
}

static translate: TranslateService;
_key: any;
GoodCode:any;
GoodName:any;
PreviousAmount:any;
PreviousValue:any;
ImportAmount:any;
ImportValue:any;
ExportAmount:any;
ExportValue:any;
TotalAmount:any;
TotalValue:any;
private _InventoryListRangeGoodReportKey:any;
get InventoryListRangeGoodReportKey(): any {
    return this._InventoryListRangeGoodReportKey;
  }
set InventoryListRangeGoodReportKey(value: any) {
    this._InventoryListRangeGoodReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryListRangeGoodReportKey == null || $this.InventoryListRangeGoodReportKey == 0;
            }


}